import React, { useEffect, useState } from 'react';
import Layout from '../components/navbar/Layout';
import TabComponent from '../components/TabComponent'; // TabComponent 경로를 수정해주세요
import AdminTab1 from '../components/admin/AdminTab1';
import AdminTab2 from '../components/admin/AdminTab2';
import AdminTab3 from '../components/admin/AdminTab3';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminPageUrl } from '../url/poenUrl';
import LoginRedirect from '../components/LoginRedirect';
import UnauthorizedMessage from '../components/UnauthorizedMessage';

function AdminPage() {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null); // 초기값 null
  const navigate = useNavigate();
  const location = useLocation();

  // 탭 데이터 정의
  const tabs = [
    { title: '공지사항', content: <AdminTab1 /> },
    { title: '회원정보 조회', content: <AdminTab2 /> },
    { title: '문의 리스트', content: <AdminTab3 /> },
  ];

  // activeTab 값을 URL 쿼리에서 읽어오기
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const activeTabFromUrl = parseInt(queryParams.get('activeTab') || '0', 10);
    setActiveTab(activeTabFromUrl);

    // 권한 확인
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions) {
      if (storedPermissions === 'ADMIN') {
        setIsAuthorized(true); // 권한 있음
      } else {
        setIsAuthorized(false); // 권한 없음
      }
    } else {
      setIsAuthorized(false); // 권한 없음
    }
  }, [location.search]);

  const handleTabChange = (index: number) => {
    // activeTab에 따라 URL을 다르게 설정
    navigate(`${AdminPageUrl}?activeTab=${index}`);
  };

  return (
    <Layout>
      <LoginRedirect />
      {isAuthorized === null ? null : !isAuthorized ? (
        <UnauthorizedMessage />
      ) : (
        <TabComponent
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      )}
    </Layout>
  );
}

export default AdminPage;
